import React, { useState } from 'react';
import './NewsGrid.css';

const NewsGrid = ({ items }) => {
  const [displayCount, setDisplayCount] = useState(5);
  const displayedItems = items.slice(0, displayCount);

  const handleLoadMore = () => {
    setDisplayCount(prevCount => prevCount + 5);
    console.debug(`Loaded 10 more items. Total displayed: ${displayCount + 5}`);
  };

  if (!Array.isArray(displayedItems) || displayedItems.length === 0) {
    console.debug('No valid RSS items provided');
    return <div className="p-4 text-center text-gray-600 font-sans">No news items available.</div>;
  }

  return (
    <div className="rss-content p-6 bg-cream-50 rounded-xl shadow-sm relative">
      <div className="rss-grid grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
        {displayedItems.map((item, index) => {
          if (!item.image) {
            return null;
          }
          const date = item.pubDate ? new Date(item.pubDate).toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          }) : 'N/A';
          
          return (
            <div
              key={`${item.link}-${index}`}
              className="news-card relative bg-white rounded-lg shadow-md border border-gold-200 overflow-hidden transition-transform duration-300 hover:-translate-y-1 animate-fade-in"
              style={{ '--index': index }}
            >
              <div className="relative image-container">
                <img
                  src={item.image}
                  srcSet={`${item.image} 300w, ${item.image} 150w`}
                  sizes="(max-width: 767px) 150px, 300px"
                  alt={item.title || 'News image'}
                  className="w-full h-20 md:h-24 object-cover transition-transform duration-500 hover:scale-105"
                  loading="lazy"
                  onError={() => console.debug(`Failed to load image for ${item.title}`)}
                />
                <div className="absolute top-2 left-2 bg-burgundy-800 text-gold-100 text-xs font-sans font-medium px-2.5 py-1 rounded-full shadow-sm">
                  {date}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-lg font-serif font-bold text-gray-900 mb-2 line-clamp-2 leading-tight">
                  {item.title || 'Untitled'}
                </h3>
                <div
                  className="text-sm text-gray-700 mb-3 font-sans leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
                <a
                  href={item.link}
                  className="inline-flex items-center text-gold-600 font-sans font-medium text-sm hover:text-gold-800 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gold-600 focus:ring-offset-2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Read more
                  <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>
            </div>
          );
        })}
      </div>
      {displayCount < items.length && (
        <div className="text-center mt-6">
          <button
            id="load-more"
            className="bg-burgundy-800 text-gold-100 font-sans font-medium px-6 py-2 rounded-full hover:bg-burgundy-900 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gold-600 focus:ring-offset-2"
            onClick={handleLoadMore}
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
};

export default NewsGrid;
